<template>
  <div class="login">
    <form class="form" @submit.prevent="handleSubmit">
      <div class="form__img">
        <img alt="logo" src="../../assets/logo_quick_pay_2022.png" />
        <p>Compra en tus tiendas favoritas</p>
        <span>Más facil, rápido y seguro</span>
      </div>
      <div class="form__inputs">
        <div class="input">
          <input
            type="text"
            placeholder="Numero de documento"
            v-model="user_doc_number"
            style="outline: none"
          />
          <i class="far fa-id-card"></i>
        </div>

        <div class="input">
          <input
            type="date"
            placeholder="Fecha de nacimiento"
            v-model="birthday_date"
            style="outline: none; width: 100%"
          />
        </div>

        <button >Validar datos</button>
      </div>
    </form>
  </div>
</template>

<script>
  // @ is an alias to /src
  import axios from 'axios'

  export default {
    name: 'PasswordRecovery',
    components: {},
    data: () => ({
      user_doc_number: '',
      birthday_date: ''
    }),
    methods: {
      async handleSubmit() {
        try {
          const response = await axios.post('password/email', {
            birthday_date: this.birthday_date,
            user_doc_number: this.user_doc_number
          })
          if (response.data.status === '200') {
            this.$swal({
              position: 'center',
              icon: 'success',
              title: 'Se envió correo de recuperación',
              showConfirmButton: false,
              timer: 2000
            })
            this.$router.push('/login')
          } else {
            this.$swal({
              position: 'center',
              icon: 'error',
              title: 'No se encuentro correo con los datos enviados',
              showConfirmButton: false,
              timer: 2000
            })
          }
        } catch (error) {
          console.log(error)
          this.$swal({
            position: 'center',
            icon: 'error',
            title: 'Ocurrio un error',
            showConfirmButton: false,
            timer: 2000
          })
        }
      }
    }
  }
</script>

<style scoped>
  /*------LOGIN------*/
  .login {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Readex Pro', sans-serif;
  }

  .form {
    width: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form__img {
    width: 100%;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form__img img {
    width: 300px;
  }

  .form__img p {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #ff3128;
  }

  .form__img span {
    margin: 0;
    font-size: 15px;
    font-weight: 300;
  }

  .form__inputs {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 20px;
    flex-direction: column;
  }
  @media (max-width: 768px) {
    .form__inputs {
      width: 80%;
      height: 100%;
      display: flex;
      margin-top: 20px;
      flex-direction: column;
    }
  }

  .form__inputs .input {
    width: 90%;
    margin: 6px auto;
    /*margin-bottom: 4px;*/
    border: 1px solid #f1f1f1;
    border-radius: 15px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .form__inputs .input input {
    border: none;
  }

  .form__inputs button {
    width: 90%;
    margin: 10px auto;
    border: none;
    border-radius: 10px;
    background: #ff3128;
    color: #fff;
    padding: 15px 10px;
    font-weight: 600;
  }

  .form__inputs .remember_account {
    width: 85%;
    margin: 15px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .form__inputs .remember_account p {
    margin: 0;
  }

  /*------LOGIN------*/
</style>
